/* MESMO theme — interactions
   Everything is looked up at the moment it is used and clicks are handled at
   document level, so the code keeps working after the theme editor re-renders
   a section. */
(function () {
  'use strict';

  /* Texts shown by the script, in the language of the page (set in the layout) */
  function text(key, fallback) {
    var strings = (window.MESMO && window.MESMO.strings) || {};
    return strings[key] || fallback;
  }

  var desktop = window.matchMedia('(min-width: 990px)');
  var menuOpen = false;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  /* Header: transparent over the hero, solid once the page scrolls */

  function updateHeader() {
    var header = qs('[data-header]');
    if (header) header.classList.toggle('is-solid', menuOpen || window.scrollY > 24);
  }

  function setMenu(open) {
    var menu = qs('[data-menu]');
    var toggle = qs('[data-menu-toggle]');
    var backdrop = qs('[data-menu-backdrop]');
    if (!menu || !toggle) return;
    menuOpen = open;
    menu.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', toggle.getAttribute(open ? 'data-label-close' : 'data-label-open') || 'Menu');
    document.body.classList.toggle('is-locked', open);
    updateHeader();
  }

  /* Search overlay */

  function setSearch(open) {
    var search = qs('[data-search]');
    if (!search) return;
    if (open) setMenu(false);
    search.hidden = !open;
    document.body.classList.toggle('is-locked', open);
    if (open) {
      qs('input[type="search"]', search).focus();
    } else {
      var opener = qs('[data-search-open]');
      if (opener) opener.focus();
    }
  }

  /* Accordions (menu groups, footer columns on mobile) */

  /* The panel follows its button, or follows the heading that wraps the button */
  function accordionPanel(button) {
    return button.nextElementSibling || button.parentElement.nextElementSibling;
  }

  function toggleAccordion(button) {
    if (button.hasAttribute('data-accordion-mobile') && desktop.matches) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    var menu = button.closest('[data-menu]');
    if (open && menu) {
      qsa('[data-accordion][aria-expanded="true"]', menu).forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        accordionPanel(other).hidden = true;
      });
    }
    button.setAttribute('aria-expanded', String(open));
    accordionPanel(button).hidden = !open;
  }

  /* Carousels: next arrow at the start, previous arrow once scrolled */

  function updateCarousel(carousel) {
    var track = qs('[data-carousel-track]', carousel);
    var prev = qs('[data-carousel-prev]', carousel);
    var next = qs('[data-carousel-next]', carousel);
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.hidden = track.scrollLeft <= 4;
    next.hidden = max <= 4 || track.scrollLeft >= max - 4;
  }

  function moveCarousel(carousel, direction) {
    var track = qs('[data-carousel-track]', carousel);
    if (!track) return;
    var slide = track.firstElementChild;
    var count = Number(carousel.getAttribute('data-carousel-step')) || 2;
    var step = slide ? (slide.getBoundingClientRect().width + 8) * count : track.clientWidth;
    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  /* Quick add: "+" folds up the size list, a size adds to the cart */

  function closeQuickPanels(except) {
    qsa('[data-quick-toggle][aria-expanded="true"]').forEach(function (toggle) {
      if (toggle === except) return;
      toggle.setAttribute('aria-expanded', 'false');
      qs('[data-quick-panel]', toggle.closest('[data-tile]')).hidden = true;
    });
  }

  /* Cart drawer. The cart markup comes from the "cart-drawer" section, so the
     drawer and the cart page always show the same thing. */

  function setCart(open) {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.classList.toggle('is-locked', open);
    if (open) qs('button[data-cart-close]', drawer).focus();
  }

  function paintCart(html) {
    var fresh = new DOMParser().parseFromString(html, 'text/html');
    var contents = qs('[data-cart-contents]', fresh);
    var drawer = qs('[data-cart-drawer]', fresh);
    if (!contents || !drawer) return;
    var count = Number(drawer.getAttribute('data-count')) || 0;
    qsa('[data-cart-contents]').forEach(function (target) {
      target.innerHTML = contents.innerHTML;
    });
    qsa('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
    qsa('[data-cart-count-text]').forEach(function (text) {
      text.textContent = '(' + count + ')';
    });
    loadCartRecs();
  }

  /* Suggestions in the cart, based on the first product. Each answer is kept, so
     changing a quantity does not ask the server again. */
  var cartRecs = {};

  function loadCartRecs() {
    qsa('[data-cart-recs]').forEach(function (slot) {
      var id = slot.getAttribute('data-product-id');
      if (!id) return;
      if (cartRecs[id] !== undefined) {
        slot.innerHTML = cartRecs[id];
        slot.hidden = cartRecs[id] === '';
        return;
      }
      cartRecs[id] = '';
      fetch(window.MESMO.routes.recommendations + '?section_id=cart-recommendations&limit=4&intent=related&product_id=' + id)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var result = qs('[data-cart-recs-result]', new DOMParser().parseFromString(html, 'text/html'));
          cartRecs[id] = result ? result.innerHTML : '';
          qsa('[data-cart-recs][data-product-id="' + id + '"]').forEach(function (other) {
            other.innerHTML = cartRecs[id];
            other.hidden = cartRecs[id] === '';
          });
        })
        .catch(function () {
          /* no suggestions; the cart works without them */
        });
    });
  }

  function refreshCartCount() {
    return fetch(window.MESMO.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        paintCart(sections['cart-drawer']);
      });
  }

  function showCartError(message) {
    qsa('[data-cart-error]').forEach(function (error) {
      error.textContent = message;
      error.hidden = false;
    });
  }

  function changeCart(key, quantity) {
    qsa('[data-cart-contents]').forEach(function (contents) {
      contents.setAttribute('aria-busy', 'true');
    });
    return fetch(window.MESMO.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || text('cartErrorUpdate', 'Could not update the cart'));
          return data;
        });
      })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) paintCart(data.sections['cart-drawer']);
        else return refreshCartCount();
      })
      .catch(function (error) {
        showCartError(error.message);
      })
      .then(function () {
        qsa('[data-cart-contents]').forEach(function (contents) {
          contents.removeAttribute('aria-busy');
        });
      });
  }

  function addToCart(button, variantId) {
    var label = button.firstElementChild;
    var original = label.textContent;
    button.disabled = true;
    fetch(window.MESMO.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId || button.getAttribute('data-add')), quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || text('cartErrorAdd', 'Could not add to cart'));
          return data;
        });
      })
      .then(function () {
        label.textContent = text('added', 'Added');
        return refreshCartCount();
      })
      .then(function () {
        closeSizeLists();
        setCart(true);
      })
      .then(function () {
        setTimeout(function () {
          label.textContent = original;
          button.disabled = false;
          closeQuickPanels();
        }, 900);
      })
      .catch(function (error) {
        label.textContent = error.message;
        setTimeout(function () {
          label.textContent = original;
          button.disabled = false;
        }, 2400);
      });
  }

  /* Tile photo gallery: arrows step through a product's photos */

  function updateTileNav(track) {
    var media = track.parentNode;
    var prev = qs('[data-tile-prev]', media);
    var next = qs('[data-tile-next]', media);
    if (!prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.hidden = track.scrollLeft <= 4;
    next.hidden = max <= 4 || track.scrollLeft >= max - 4;
  }

  function moveTile(button, direction) {
    var track = qs('[data-tile-track]', button.parentNode);
    if (track) track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
  }

  /* Product / Model toggle: moves every tile to its product photo or its model photo */

  var VIEW_KEY = 'mesmo:view';
  var view = 'product';
  try {
    if (localStorage.getItem(VIEW_KEY) === 'model') view = 'model';
  } catch (error) {
    /* storage unavailable: start on Product */
  }

  function applyView() {
    var buttons = qsa('[data-view]');
    if (!buttons.length) return;
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-view') === view));
    });
    qsa('[data-collection] [data-tile-track]').forEach(function (track) {
      var index = view === 'model' ? Number(track.getAttribute('data-model-index')) || 0 : 0;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
      updateTileNav(track);
    });
  }

  function setView(next) {
    view = next === 'model' ? 'model' : 'product';
    try {
      localStorage.setItem(VIEW_KEY, view);
    } catch (error) {
      /* storage unavailable: the choice lasts for this page view */
    }
    applyView();
  }

  /* Collection page: the next products load when the end of the grid comes into view */

  var loadingMore = false;
  var nextCheckQueued = false;

  /* Checked on scroll rather than with an observer, so jumping straight to the
     footer still loads the products that were skipped. */
  function observeNext() {
    if (nextCheckQueued) return;
    nextCheckQueued = true;
    requestAnimationFrame(function () {
      nextCheckQueued = false;
      var link = qs('[data-next]:not([data-failed])');
      if (link && link.getBoundingClientRect().top < window.innerHeight + 600) loadMore(link);
    });
  }

  function loadMore(link) {
    if (loadingMore) return;
    var section = link.closest('[data-collection]');
    var grid = section && qs('[data-grid]', section);
    if (!grid) return;
    loadingMore = true;
    link.classList.add('is-loading');
    var label = qs('[data-next-label]', link);
    if (label) label.textContent = text('loadingMore', 'Loading more');

    var url = link.href + (link.href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(section.getAttribute('data-section-id'));
    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.text();
      })
      .then(function (html) {
        var page = new DOMParser().parseFromString(html, 'text/html');
        var items = qsa('[data-grid] > *', page);
        if (!items.length) throw new Error('No products in response');
        items.forEach(function (item) {
          grid.appendChild(document.importNode(item, true));
        });
        var more = qs('[data-more]', section);
        var nextMore = qs('[data-more]', page);
        more.innerHTML = nextMore ? nextMore.innerHTML : '';
        loadingMore = false;
        refresh();
      })
      .catch(function () {
        /* fall back to a normal link to the next page */
        loadingMore = false;
        link.classList.remove('is-loading');
        link.setAttribute('data-failed', '');
        if (label) label.textContent = text('loadMore', 'Load more');
        observeNext();
      });
  }

  /* Product page: size selector, add to cart, sticky bar, size guide */

  function closeSizeLists() {
    qsa('[data-size-toggle][aria-expanded="true"]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      qs('[data-size-list]', toggle.closest('[data-buy-box]')).hidden = true;
    });
  }

  function toggleSizeList(toggle) {
    var list = qs('[data-size-list]', toggle.closest('[data-buy-box]'));
    var open = list.hidden;
    closeSizeLists();
    toggle.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
  }

  /* Choosing a size updates every buy box on the page (info panel and sticky bar) */
  function selectVariant(option) {
    var id = option.getAttribute('data-variant');
    qsa('[data-buy-box]').forEach(function (box) {
      var input = qs('[data-variant-input]', box);
      var label = qs('[data-size-label]', box);
      if (input) {
        input.value = id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (label) label.textContent = option.getAttribute('data-label');
      qs('[data-price-text]', box).textContent = option.getAttribute('data-price');
      qs('[data-compare-text]', box).textContent = option.getAttribute('data-compare');
      qsa('[data-variant]', box).forEach(function (other) {
        if (other.getAttribute('data-variant') === id) other.setAttribute('aria-current', 'true');
        else other.removeAttribute('aria-current');
      });
      box.setAttribute('data-state', 'ready');
      qs('[data-add-button]', box).disabled = false;
      qs('[data-add-label]', box).textContent = box.getAttribute('data-add-text') || text('addToCart', 'Add to cart');
    });
    qsa('[data-guide-size]').forEach(function (row) {
      row.classList.toggle('is-selected', row.getAttribute('data-guide-size') === option.getAttribute('data-label'));
    });
    closeSizeLists();
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    } catch (error) {
      /* the address bar keeps the old link; the selection still works */
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.buy__form')) return;
    event.preventDefault();
    var box = form.closest('[data-buy-box]');
    var input = qs('[data-variant-input]', form);
    if (!input || !input.value) {
      var toggle = qs('[data-size-toggle]', box);
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggleSizeList(toggle);
      return;
    }
    var button = qs('[data-add-button]', box);
    if (!button.disabled) addToCart(button, input.value);
  });

  function setGuide(open) {
    var guide = qs('[data-guide]');
    if (!guide) return;
    guide.hidden = !open;
    document.body.classList.toggle('is-locked', open);
    if (open) qs('button[data-guide-close]', guide).focus();
  }

  /* The sticky bar shows once the main buy box has scrolled out of view */
  function updateSticky() {
    var bar = qs('[data-sticky-buy]');
    var main = qs('[data-main-buy]');
    if (!bar || !main) return;
    var past = main.getBoundingClientRect().bottom < 0;
    if (bar.hidden === past) {
      closeSizeLists();
      bar.hidden = !past;
    }
    /* Lift the chat button above the sticky bar while the bar is showing */
    document.documentElement.style.setProperty('--chat-lift', past ? bar.offsetHeight + 'px' : '0px');
  }

  /* Text pages: every heading gets a readable anchor (so other pages can link
     straight to a section), and long pages get an "On this page" list. */
  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildPageContents() {
    var content = qs('[data-page-content]');
    if (!content || content.hasAttribute('data-anchored')) return;
    content.setAttribute('data-anchored', '');
    var used = {};
    qsa('h2, h3', content).forEach(function (heading, index) {
      if (heading.id) return;
      var base = slugify(heading.textContent) || 'section-' + (index + 1);
      var id = base;
      var count = 2;
      while (used[id] || document.getElementById(id)) id = base + '-' + count++;
      used[id] = true;
      heading.id = id;
    });

    var toc = qs('[data-page-toc]');
    var list = qs('[data-page-toc-list]');
    if (toc && list) {
      var headings = qsa('h2', content);
      if (headings.length < 4) headings = qsa('h2, h3', content);
      if (headings.length >= 4) {
        headings.forEach(function (heading) {
          var item = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          if (heading.tagName === 'H2') item.className = 'page__toc-main';
          item.appendChild(link);
          list.appendChild(item);
        });
        toc.hidden = false;
      }
    }

    /* A link from another page arrives before the anchors exist; go there now */
    if (window.location.hash.length > 1) {
      var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (target) target.scrollIntoView();
    }
  }

  /* Shopify Inbox: links marked data-chat-open open the chat window. Without the
     chat on the page they keep working as normal links. */
  function openChat() {
    var chat = qs('shopify-chat');
    if (!chat) return false;
    if (typeof chat.show === 'function') chat.show();
    else if ('open' in chat) chat.open = true;
    else return false;
    return true;
  }

  /* Expected delivery date: orders before the cut-off on a working day ship that day,
     and arrive the next day (Monday when that would be a Sunday). Amsterdam time. */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function deliveryDate(now, cutoff) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hour12: false
    }).formatToParts(now);
    function part(type) {
      return Number(
        parts.filter(function (item) {
          return item.type === type;
        })[0].value
      );
    }
    var date = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
    var weekend = date.getUTCDay() === 0 || date.getUTCDay() === 6;
    if (weekend || part('hour') % 24 >= cutoff) {
      do {
        date.setUTCDate(date.getUTCDate() + 1);
      } while (date.getUTCDay() === 0 || date.getUTCDay() === 6);
    }
    date.setUTCDate(date.getUTCDate() + 1);
    if (date.getUTCDay() === 0) date.setUTCDate(date.getUTCDate() + 1);
    var language = document.documentElement.lang || 'en';
    if (language.indexOf('en') !== 0) {
      try {
        return new Intl.DateTimeFormat(language, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
      } catch (error) {
        /* fall through to the English format */
      }
    }
    return DAYS[date.getUTCDay()] + ', ' + date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()];
  }

  function paintDeliveryDates() {
    qsa('[data-delivery-date]').forEach(function (element) {
      try {
        element.textContent = deliveryDate(new Date(), Number(element.getAttribute('data-cutoff')) || 18);
      } catch (error) {
        /* keep the text set in the theme editor */
      }
    });
  }
  window.MESMO_deliveryDate = deliveryDate;

  /* "Complete your outfit": complementary products first, related products otherwise */
  function loadRecommendations() {
    var section = qs('[data-recommendations]:not([data-loaded])');
    if (!section) return;
    section.setAttribute('data-loaded', '');
    var base = section.getAttribute('data-url');

    function attempt(intent) {
      return fetch(base + '&intent=' + intent)
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var fresh = qs('[data-recommendations]', new DOMParser().parseFromString(html, 'text/html'));
          if (!fresh || !qs('[data-tile]', fresh)) return false;
          section.innerHTML = fresh.innerHTML;
          section.hidden = false;
          paintWishlist();
          return true;
        });
    }

    attempt('complementary')
      .then(function (found) {
        return found || attempt('related');
      })
      .catch(function () {
        /* the section simply stays hidden */
      });
  }

  /* Wishlist: kept in this browser for now */

  var WISH_KEY = 'mesmo:wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  var wishlist = readWishlist();

  function paintWishlist() {
    qsa('[data-wish]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(wishlist.indexOf(button.getAttribute('data-wish')) > -1));
    });
  }

  function toggleWish(button) {
    var handle = button.getAttribute('data-wish');
    var index = wishlist.indexOf(handle);
    if (index > -1) wishlist.splice(index, 1);
    else wishlist.push(handle);
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(wishlist));
    } catch (error) {
      /* storage unavailable: the heart still toggles for this page view */
    }
    paintWishlist();
  }

  /* Video sound toggle: only one video plays sound at a time */

  function setSound(block, on) {
    var video = qs('[data-video]', block);
    var button = qs('[data-sound]', block);
    if (!video || !button) return;
    video.muted = !on;
    button.setAttribute('aria-pressed', String(on));
    qs('[data-sound-label]', button).textContent = button.getAttribute(on ? 'data-label-on' : 'data-label-off') || (on ? 'Sound on' : 'Sound off');
  }

  function toggleSound(button) {
    var block = button.closest('[data-video-block]');
    var video = block && qs('[data-video]', block);
    if (!video) return;
    var on = video.muted;
    qsa('[data-video-block]').forEach(function (other) {
      if (other !== block) setSound(other, false);
    });
    setSound(block, on);
  }

  /* MESMO Circle signup: the form saves the member in Shopify as usual. While
     Omnisend's script is still on the page, tell Omnisend first so its automation
     can send the welcome email straight away, then let the form continue. Without
     Omnisend this part does nothing and can be removed after the move to Shopify. */

  var OMNISEND_EVENT = 'MESMO Circle signup';

  /* Date of birth is typed as DD/MM/YYYY and saved as year-month-day */
  function parseBirthday(value) {
    var match = /^(\d{1,2})\D(\d{1,2})\D(\d{4})$/.exec(value.trim());
    if (!match) return '';
    var day = Number(match[1]);
    var month = Number(match[2]);
    var year = Number(match[3]);
    var date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return '';
    if (year < 1900 || date > new Date()) return '';
    return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
  }

  /* Adds the slashes while typing */
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field.matches || !field.matches('[data-member-birthday]')) return;
    field.setCustomValidity('');
    if (event.inputType && event.inputType.indexOf('delete') === 0) return;
    var digits = field.value.replace(/\D/g, '').slice(0, 8);
    var text = digits.slice(0, 2);
    if (digits.length >= 2) text += '/' + digits.slice(2, 4);
    if (digits.length >= 4) text += '/' + digits.slice(4);
    field.value = text;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.member-form')) return;
    if (form.hasAttribute('data-signalled')) return;

    /* Date of birth: saved on the customer in Shopify as a tag, without an app */
    var birthdayField = qs('[data-member-birthday]', form);
    var tagsField = qs('[data-member-tags]', form);
    var birthday = '';
    if (birthdayField) {
      birthdayField.setCustomValidity('');
      if (birthdayField.value.trim()) {
        birthday = parseBirthday(birthdayField.value);
        if (!birthday) {
          event.preventDefault();
          birthdayField.setCustomValidity(text('birthdayInvalid', 'Please enter your date of birth as DD/MM/YYYY.'));
          birthdayField.reportValidity();
          return;
        }
      }
    }
    if (tagsField) {
      var tags = tagsField.value.split(',').filter(function (tag) {
        return tag.indexOf('birthday:') !== 0 && tag.indexOf('birthday-') !== 0;
      });
      /* Full date, plus month and day on their own so a daily Shopify Flow can
         find today's birthdays whatever the year */
      if (birthday) tags.push('birthday:' + birthday, 'birthday-' + birthday.slice(5));
      tagsField.value = tags.join(',');
    }

    var omnisend = window.omnisend;
    var input = qs('input[name="contact[email]"]', form);
    if (!input || !omnisend || typeof omnisend.identifyContact !== 'function') return;

    event.preventDefault();
    var done = false;
    function proceed() {
      if (done) return;
      done = true;
      form.setAttribute('data-signalled', '');
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }

    try {
      var contact = { email: input.value.trim() };
      if (birthday) contact.birthdate = birthday;
      omnisend.identifyContact(contact);
      omnisend.push([
        'track',
        OMNISEND_EVENT,
        {
          origin: 'api',
          properties: { source: form.getAttribute('data-source') || 'footer', page: window.location.pathname },
          callbacks: { onSuccess: proceed, onError: proceed }
        }
      ]);
    } catch (error) {
      proceed();
    }
    setTimeout(proceed, 1500);
  });

  /* One click handler for the whole page */

  document.addEventListener('click', function (event) {
    var target = event.target;
    var hit;

    if (target.closest('[data-menu-toggle]')) return setMenu(!menuOpen);
    if (target.closest('[data-menu-backdrop]')) return setMenu(false);
    if (target.closest('[data-search-open]')) return setSearch(true);
    if (target.closest('[data-search-close]')) return setSearch(false);
    if ((hit = target.closest('[data-accordion]'))) return toggleAccordion(hit);
    if ((hit = target.closest('[data-carousel-prev]'))) return moveCarousel(hit.closest('[data-carousel]'), -1);
    if ((hit = target.closest('[data-carousel-next]'))) return moveCarousel(hit.closest('[data-carousel]'), 1);
    if ((hit = target.closest('[data-sound]'))) return toggleSound(hit);
    if ((hit = target.closest('[data-view]'))) return setView(hit.getAttribute('data-view'));
    if ((hit = target.closest('[data-size-toggle]'))) return toggleSizeList(hit);
    if ((hit = target.closest('[data-variant]'))) {
      if (!hit.disabled) selectVariant(hit);
      return;
    }
    if ((hit = target.closest('[data-page-toc-list] a'))) {
      var tocHead = qs('[data-page-toc] [data-accordion]');
      if (tocHead && !desktop.matches && tocHead.getAttribute('aria-expanded') === 'true') toggleAccordion(tocHead);
      return;
    }
    if ((hit = target.closest('[data-map-load]'))) {
      var mapBox = hit.closest('[data-map]');
      var frame = document.createElement('iframe');
      frame.src = hit.getAttribute('data-src');
      frame.title = hit.getAttribute('data-title') || 'Map';
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.allowFullscreen = true;
      mapBox.textContent = '';
      mapBox.appendChild(frame);
      return;
    }
    if (target.closest('[data-chat-open]')) {
      if (openChat()) event.preventDefault();
      return;
    }
    if (target.closest('[data-cart-open]')) {
      event.preventDefault();
      setCart(true);
      return refreshCartCount();
    }
    if (target.closest('[data-cart-close]')) return setCart(false);
    if ((hit = target.closest('[data-qty]'))) {
      var line = hit.closest('[data-cart-item]');
      var next = Number(line.getAttribute('data-quantity')) + Number(hit.getAttribute('data-qty'));
      return changeCart(line.getAttribute('data-key'), Math.max(next, 0));
    }
    if ((hit = target.closest('[data-cart-remove]'))) {
      return changeCart(hit.closest('[data-cart-item]').getAttribute('data-key'), 0);
    }
    if (target.closest('[data-guide-open]')) return setGuide(true);
    if (target.closest('[data-guide-close]')) return setGuide(false);
    if (!target.closest('[data-buy-box]')) closeSizeLists();
    if ((hit = target.closest('[data-tile-prev]'))) return moveTile(hit, -1);
    if ((hit = target.closest('[data-tile-next]'))) return moveTile(hit, 1);
    if ((hit = target.closest('[data-next]')) && !hit.hasAttribute('data-failed')) {
      event.preventDefault();
      return loadMore(hit);
    }

    if ((hit = target.closest('[data-quick-toggle]'))) {
      var open = hit.getAttribute('aria-expanded') !== 'true';
      closeQuickPanels(hit);
      hit.setAttribute('aria-expanded', String(open));
      qs('[data-quick-panel]', hit.closest('[data-tile]')).hidden = !open;
      return;
    }
    if ((hit = target.closest('[data-add]'))) {
      if (!hit.disabled) addToCart(hit);
      return;
    }
    if (!target.closest('[data-quick-panel]')) closeQuickPanels();
    if ((hit = target.closest('[data-wish]'))) toggleWish(hit);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var search = qs('[data-search]');
    var guide = qs('[data-guide]');
    var cartDrawer = qs('[data-cart-drawer]');
    closeSizeLists();
    if (cartDrawer && !cartDrawer.hidden) {
      setCart(false);
    } else if (guide && !guide.hidden) {
      setGuide(false);
    } else if (search && !search.hidden) {
      setSearch(false);
    } else if (menuOpen) {
      setMenu(false);
      var toggle = qs('[data-menu-toggle]');
      if (toggle) toggle.focus();
    }
  });

  /* Scroll does not bubble, so listen in the capture phase to catch carousel tracks */
  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.matches) return;
      if (track.matches('[data-carousel-track]')) updateCarousel(track.closest('[data-carousel]'));
      else if (track.matches('[data-tile-track]')) updateTileNav(track);
    },
    true
  );

  function refresh() {
    updateHeader();
    paintWishlist();
    qsa('[data-carousel]').forEach(updateCarousel);
    qsa('[data-tile-track]').forEach(updateTileNav);
    applyView();
    observeNext();
    updateSticky();
    loadCartRecs();
    buildPageContents();
    paintDeliveryDates();
    loadRecommendations();
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('scroll', observeNext, { passive: true });
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', function () {
    qsa('[data-carousel]').forEach(updateCarousel);
    applyView();
  });

  /* Theme editor: a section was re-rendered, so its state starts fresh */
  document.addEventListener('shopify:section:load', function () {
    menuOpen = false;
    document.body.classList.remove('is-locked');
    refresh();
  });

  refresh();
})();
